import React from 'react';

const Phone = () => {
  return (
    <svg
      version="1.1"
      id="phone_icon"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style="enable-background:new 0 0 24 24;"
      space="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        stroke: 'currentColor',
        verticalAlign: 'middle',
      }}
    >
      <path d="M8.26,1.29L6.7,2.06c-5.79,3.02,2.8,20.94,9.31,20.94c0.46,0,0.9-0.09,1.32-0.28l1.54-0.75l-2.9-5.59	l-1.54,0.75c-0.18,0.09-0.38,0.13-0.6,0.13c-2.56,0-6.84-8.2-4.24-9.6l1.55-0.76L8.26,1.29z M16.01,24	C10.33,24,3.79,12.89,3.79,6.17c0-2.42,0.83-4.15,2.46-4.99L8.62,0l3.86,7.35l-2.44,1.2c-1.44,0.77,2.41,8.42,3.96,7.68l2.4-1.18	l3.82,7.36c0,0-2.36,1.16-2.48,1.22C17.19,23.87,16.61,24,16.01,24" />
    </svg>
  );
};

export default Phone;
